import { jsx as _jsx } from "react/jsx-runtime";
// ---Third-party imports
import React from 'react';
import { Popup } from 'semantic-ui-react';
// ---Framework imports
import log from 'uix/logging';
import { useFullscreenContext } from 'uix/hooks';
// ---Exports
export const XPopup = ({ fitted, children, style, position, autoPosition = false, ...props })=>{
    /* sui-popup with fullscreen support
   */ let { domNode } = useFullscreenContext();
    let styles = {
        ...style,
        ...fitted && {
            padding: '0'
        }
    };
    if (!autoPosition && !position) {
        // default react-popper (sui changes this to "top left")
        position = 'bottom center';
    }
    // popperModifiers=[{name: 'preventOverflow', enabled:true, options: {boundary: 'viewport'}}]
    let offset = [] // XXX: only setting a pseudo offset enables a preventOverflow modifier (see popperModifiers in sui-react/Popup.js)
    ;
    return /*#__PURE__*/ _jsx(Popup, {
        style: styles,
        ...props,
        ...position ? {
            position
        } : {},
        mountNode: domNode || undefined,
        offset: offset,
        children: children
    });
};
